import { render, staticRenderFns } from "./service-advertisement.vue?vue&type=template&id=4ed6b60f"
import script from "./service-advertisement.vue?vue&type=script&lang=js"
export * from "./service-advertisement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports